import NotaFiscalSaidaEmissao from "./NotaFiscalSaidaEmissao";

export default function NotaFiscalSaidaEdicao() {
    return <NotaFiscalSaidaEmissao edicao />;
}